import {DocumentMeta} from "./DocumentMeta";
import {MetaValueType} from "./MetaValueType";

export class MetaObject {
	_metaData : DocumentMeta[];
	

	constructor(metaData: DocumentMeta[]|null|undefined) {
		this._metaData = metaData ?? [];
	}

	public get MetaData() {
		return this._metaData;
	}
	public set MetaData(metaData) {
		this._metaData = metaData;
	}
	
	public get target(): string|undefined {
		return this.getMetaValue("target");
	}
	public set target(value: string|undefined) {
		this.setMetaValue( "target",value);
	}
	
	public get targetFileName(): string|undefined {
		return this.getMetaValue("targetFileName");
	}
	
	public set targetFileName(value: string|undefined) {
		this.setMetaValue( "targetFileName",value);
	}
	
	public get customerId(): string|undefined {
		return this.getMetaValue("customerId");
	}
	public set customerId(value: string|undefined) {
		this.setMetaValue( "customerId",value);
	}

	public get brokerId(): string|undefined {
		return this.getMetaValue("brokerId");
	}

	public get brokerName(): string|undefined {
		return this.getMetaValue("brokerName");
	}

	public get mailSubject(): string|undefined {
		return this.getMetaValue("mailSubject");
	}
	public get mailSender(): string|undefined {
		return this.getMetaValue("mailSender");
	}
	public get mailReplyTo(): (string | undefined)[] {
		return this.getMetaValues("mailReplyTo");
	}
	public get mailTo(): (string | undefined)[] {
		return this.getMetaValues("mailTo");
	}

	public get mailCc(): (string | undefined)[] {
		return this.getMetaValues("mailCc");
	}
	
	public get newClaim(): boolean|undefined {
		return this.getMetaValueBoolean("newClaim");
	}
	public set newClaim(value: boolean|undefined) {
		this.setMetaValue( "newClaim",value?"true":undefined);
	}
	
	public get claimInjury(): boolean|undefined {
		return this.getMetaValueBoolean("claimInjury");
	}
	
	public get newTask(): boolean|undefined {
		return this.getMetaValueBoolean("newTask");
	}
	public set newTask(value: boolean|undefined) {
		this.setMetaValue( "newTask",value?"true":undefined);
	}

	public get taskUrgent(): boolean|undefined {
		return this.getMetaValueBoolean("taskUrgent");
	}
	public set taskUrgent(value: boolean|undefined) {
		this.setMetaValue( "taskUrgent",value?"true":undefined);
	}

	public get assignedUser(): string|undefined {
		return this.getMetaValue("assignedUser");
	}
	public set assignedUser(value: string|undefined) {
		this.setMetaValue( "assignedUser",value);
	}

	public get policyIsPackage(): boolean|undefined {
		return this.getMetaValueBoolean("policyIsPackage");
	}

	public getMetaValueBoolean(key: string) {
		return (this._metaData.filter((it) => it.key === key).firstOrNull()?.value)?.toLowerCase() === "true";
	}
	public getMetaValue(key: string) {
		return this._metaData.filter((it) => it.key === key).firstOrNull()?.value;
	}

	private getMetaValues(key: string) {
		return this._metaData.filter((it) => it.key === key).map(x=> x.value);
	}

	private setMetaValue(key:string, value: string|number|boolean|undefined) {
		let meta = this._metaData.filter((it) => it.key === key).firstOrNull();

		this._metaData.forEach( (item, index) => {
			if(item.key === key) this._metaData.splice(index,1);
		});
		//this._metaData = [...this._metaData.filter((it=> it.key !== key))];

		if (value) {
			if (!meta) {
				meta = {key: key, value : value.toString(), valueType: MetaValueType.String, timeStamp:new Date().toISOString(), changed: true, selected : true};
				this._metaData.splice(0,0,meta);
			} else if (meta.value !== value.toString()) {
				meta.value = value?.toString()??"";
				meta.changed = true;
				meta.timeStamp = new Date().toISOString();
			}

			//this._metaData = [...this._metaData, meta];
		}
	}
}
